import React, { useState } from "react";
import { Modal, ModalHeader } from "reactstrap";
import { useFormik } from "formik";
import * as Yup from "yup";
import { addMda } from "common/services/mda.service";
import MdaForm from "./MdaForm";
import { toast } from "react-toastify";
import { extractFieldErrors } from "common/lib/fieldErrors";

const AddMDA: React.FC<{
  toggle: () => void;
  isModalOpen: boolean;
  fetchData: () => void;
}> = ({ toggle, isModalOpen, fetchData }) => {
  const [loading, setLoading] = useState<boolean>(false);
  const [fieldErrors, setFieldErrors] = useState<any>([]);
  // validation
  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,
    initialValues: {
      name: "",
      acronym: "",
      region: {
        value: "",
        label: "",
      },
    },
    validationSchema: Yup.object({
      name: Yup.string().required("Please enter name"),
      acronym: Yup.string(),
      region: Yup.object().shape({
        value: Yup.string().required("Please select region"),
      }),
    }),
    onSubmit: async (values: any) => {
      const data = {
        data: {
          name: values.name ? values.name.trim() : null,
          acronym: values.acronym ? values.acronym.trim() : null,
          region: values.region.value,
        },
      };
      // save new order
      setLoading(true);
      try {
        await addMda(data);
        fetchData();
        validation.resetForm();
        toggle();
        toast.success("MDA Added Successfully", {});
      } catch (e: any) {
        const errors = extractFieldErrors(e?.response);
        setFieldErrors(errors);
        toast.error("MDA Creation Failed", {});
      } finally {
        setLoading(false);
      }
    },
  });

  return (
    <Modal
      id="showModal"
      size="lg"
      isOpen={isModalOpen}
      toggle={toggle}
      centered
    >
      <ModalHeader className="bg-light p-3" toggle={toggle}>
        Add Ministry, Department or Agency
      </ModalHeader>

      <MdaForm
        validation={validation}
        isUpdate={false}
        loading={loading}
        toggle={toggle}
        fieldErrors={fieldErrors}
      />
    </Modal>
  );
};

export default AddMDA;
